import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/admin/Dashboard";
import VisitorLogs from "./pages/admin/VisitorLogs";
import Lists from "./pages/admin/Lists";
import Briefings from "./pages/admin/Briefings";
import Users from "./pages/admin/Users";
import SettingsPage from "./pages/admin/SettingsPage";
import AuditLogPage from "./pages/admin/AuditLogPage";
import PreRegister from "./pages/employee/PreRegister";
import KioskHome from "./pages/kiosk/KioskHome";
import CheckInFlow from "./pages/kiosk/CheckInFlow";
import CheckOutFlow from "./pages/kiosk/CheckOutFlow";
import InvitePublic from "./pages/InvitePublic";
import UserManual from "./pages/UserManual";
import AdminLayout from "./components/layout/AdminLayout";
import "./App.css";

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "security") return <Navigate to="/kiosk" replace />;
  if (user.role === "employee") return <Navigate to="/pre-register" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite/:token" element={<InvitePublic />} />
          <Route path="/usermanual" element={<UserManual />} />

          <Route path="/kiosk" element={<ProtectedRoute roles={["admin", "security"]}><KioskHome /></ProtectedRoute>} />
          <Route path="/kiosk/checkin" element={<ProtectedRoute roles={["admin", "security"]}><CheckInFlow /></ProtectedRoute>} />
          <Route path="/kiosk/checkout" element={<ProtectedRoute roles={["admin", "security"]}><CheckOutFlow /></ProtectedRoute>} />

          <Route path="/dashboard" element={<ProtectedRoute roles={["admin"]}><AdminLayout><Dashboard /></AdminLayout></ProtectedRoute>} />
          <Route path="/visitor-logs" element={<ProtectedRoute roles={["admin"]}><AdminLayout><VisitorLogs /></AdminLayout></ProtectedRoute>} />
          <Route path="/lists" element={<ProtectedRoute roles={["admin"]}><AdminLayout><Lists /></AdminLayout></ProtectedRoute>} />
          <Route path="/briefings" element={<ProtectedRoute roles={["admin"]}><AdminLayout><Briefings /></AdminLayout></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute roles={["admin"]}><AdminLayout><Users /></AdminLayout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute roles={["admin"]}><AdminLayout><SettingsPage /></AdminLayout></ProtectedRoute>} />
          <Route path="/audit-log" element={<ProtectedRoute roles={["admin"]}><AdminLayout><AuditLogPage /></AdminLayout></ProtectedRoute>} />
          <Route path="/pre-register" element={<ProtectedRoute roles={["employee", "admin"]}><AdminLayout><PreRegister /></AdminLayout></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
